import { createSelector } from '@ngrx/store';
import { AppStateInterface } from '../types';

export const selectJobsData = (state: AppStateInterface) => state.jobsData;
export const selectJobFavoritesData = (state: AppStateInterface) => state.jobFavoritesData;

export const isLoadingJobsDataSelector = createSelector(
  selectJobsData,
  (state) => state.isLoading,
);
export const successJobsDataSelector = createSelector(
  selectJobsData,
  (state) => state.jobs,
);
export const errorJobsDataSelector = createSelector(
  selectJobsData,
  (state) => state.error,
);

export const successJobFavoritesDataSelector = createSelector(
  selectJobFavoritesData,
  (state) => state.jobSlugs,
);
export const errorJobFavoritesDataSelector = createSelector(
  selectJobFavoritesData,
  (state) => state.error,
);
